import React, { useContext, useEffect, useState } from 'react'
import AccessLogs from '../EPCRView/AccessLogs'
import { useNavigate, useParams } from 'react-router-dom'
import API from '../../../../services/API'
import { GlobalContext } from '../../../../App'
import { LinearProgress, Stack, Typography } from '@mui/material'
import DataPanel from './DataPanel'
import Header from './Header'

const UninjuredReportView = () => {
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [record, setRecord] = useState(null)
  const navigate = useNavigate()
  const { setToast } = useContext(GlobalContext)

  useEffect(() => {
    API.get('/uninjured-report/' + id).then((res) => {
      if (res.status === 200) {
        setRecord(res.data)
        setLoading(false)
      } else if (res.status === 403) {
        navigate('/patient-report-forms')
      } else {
        setToast({
          message: 'Unable to fetch record. Please try again later',
          severity: 'error',
        })
      }
    })
  }, [])

  return (
    <>
      {loading ? (
        <LinearProgress />
      ) : (
        <Stack gap={2}>
          <Header record={record} />
          <Stack paddingX={1} alignItems="center">
            <Typography variant="caption" color="#c00000">
              The information contained herein is privileged and confidential
              and is protected by UK Data Protection laws, including the Data
              Protection Act 2018, and the Computer Misuse Act 1990.
            </Typography>
            <Typography variant="caption" color="#c00000">
              Any unauthorised access, disclosure, distribution, or use of this
              software is strictly prohibited.
            </Typography>
          </Stack>
          <DataPanel record={record} />
        </Stack>
      )}
    </>
  )
}

export default UninjuredReportView
